var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForecastsIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    clipPath: "url(#clip0_3_94157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 0H4C1.79086 0 0 1.79086 0 4V30C0 32.2091 1.79086 34 4 34H30C32.2091 34 34 32.2091 34 30V4C34 1.79086 32.2091 0 30 0Z",
    fill: "#F7F3E3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.98 12.53C10.37 12.53 9.07001 11.22 9.07001 9.61996C9.07001 8.01996 10.38 6.70996 11.98 6.70996C13.58 6.70996 14.89 8.01996 14.89 9.61996C14.89 11.22 13.58 12.53 11.98 12.53ZM11.98 8.08996C11.14 8.08996 10.45 8.77996 10.45 9.61996C10.45 10.46 11.14 11.15 11.98 11.15C12.82 11.15 13.51 10.46 13.51 9.61996C13.51 8.77996 12.82 8.08996 11.98 8.08996Z",
    fill: "#09363F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.2 27.2899H9.76002L9.07002 26.5999V21.1299C8.15002 20.9299 7.46002 20.1199 7.46002 19.1399V15.4399C7.46002 14.3199 8.37002 13.4099 9.49002 13.4099H15.5V14.7899H9.49002C9.13002 14.7899 8.84002 15.0799 8.84002 15.4399V19.1399C8.84002 19.4999 9.13002 19.7899 9.49002 19.7899H9.75002L10.44 20.4799V25.8999H13.5V19.7299H14.88V26.5899L14.19 27.2799L14.2 27.2899Z",
    fill: "#09363F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.48 22.2699L17.4 19.9199L17.05 19.3199V14.6099L17.4 14.0099L21.48 11.6599H22.17L26.25 14.0099L26.6 14.6099V19.3199L26.25 19.9199L22.17 22.2699H21.48ZM18.4401 18.9199L21.83 20.8799L25.22 18.9199V15.0099L21.83 13.0599L18.4401 15.0099V18.9199Z",
    fill: "#09363F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.51 14.7201V19.2101L21.82 19.6001L21.13 19.2101V14.7201L21.82 14.3301L22.51 14.7201Z",
    fill: "#09363F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_94157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecastsIcon3);
export default __webpack_public_path__ + "static/media/forecasts_icon3.052bf9df6cc069df8c8b5357ac217a8e.svg";
export { ForwardRef as ReactComponent };